import type { ReactNode } from 'react';
import { Link } from '@/lib/router';

// A page that is not there (yet, or at all).
export function Placeholder(props: { title: string; text: string }): ReactNode {
    return (
        <div className="page page-scroll">
            <div className="panel placeholder">
                <h2>{props.title}</h2>
                <p>{props.text}</p>
                <Link className="act primary" to="/">
                    Back to Explore
                </Link>
            </div>
        </div>
    );
}
